import { useEffect } from 'react'
import { useState } from 'react'

import { useRouter } from 'next/router'

import classnames from 'classnames'

import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './AccordionItem.module.css'

export interface AccordionItemProps {
  title: string
  _key: string
  body?: PortableTextComponentProps['blocks']
  isOpen?: boolean
  className?: string
  onClick?: (evt: any) => void
  testID?: string
}

export default function AccordionItem({
  _key,
  title,
  body,
  isOpen = false,
  onClick,
  testID,
}: AccordionItemProps) {
  const [isShowing, setIsShowing] = useState(isOpen)
  const router = useRouter()

  const toggleBody = (evt: any) => {
    setIsShowing(!isShowing)
    onClick?.(evt)
  }

  useEffect(() => {
    setIsShowing(isOpen)
  }, [isOpen])

  return (
    <li>
      <h3>
        <button
          className={classnames({ [styles.isOpen]: isShowing }, styles.header)}
          onClick={evt => toggleBody(evt)}
          data-testid={testID && `${testID}-trigger`}
          aria-controls={`content-${_key}`}
          aria-expanded={isShowing}
          id={`accordion-control-${_key}`}
        >
          <Text
            Tag="span"
            size={TextSizes.primaryTitleSml}
            className={styles.title}
          >
            {title}
          </Text>
        </button>
      </h3>
      <div
        className={classnames(
          styles.body,
          isShowing && styles.bodyShowing,
          (router.asPath === '/artist-grayson-perry' ||
            router.asPath === '/artist-damien-hirst') &&
            'accordionItem'
        )}
        data-testid={testID && `${testID}-body`}
        aria-hidden={!isShowing}
        id={`content-${_key}`}
      >
        <div className={`${styles.bodyText} prose`}>
          <BlockContent value={body}></BlockContent>
        </div>
      </div>
    </li>
  )
}
